import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { prod } from '../catalog/slice/prod';
import { printDialog } from '../common/slice/printDialog';
import {
  OKShareButton,
  TelegramShareButton,
  TwitterShareButton,
  VKShareButton,
} from 'react-share';
import copy from 'copy-to-clipboard';
import Modal from '../common/cmpt/modal/Modal';

export const onScroll = (nodeId, height) => {
  const node = document.getElementById(nodeId);
  if (node === null) {
    return;
  }

  const trackScroll = () => {
    const scroll = window.scrollY;

    if (scroll >= height) {
      node.classList.add('clinker-facing__act');
    } else {
      node.classList.remove('clinker-facing__act');
    }
  };

  window.addEventListener('scroll', trackScroll);
};

const HeaderFixed = ({ prod: item, shareUrl }) => {
  const dispatch = useDispatch();
  const { compare } = useSelector((state) => state.prod);

  const { id, name } = item;
  const [modal, setModal] = useState(false);
  const inCompare = compare.find((pId) => pId === id);

  const toggleCompare = (evt) => {
    dispatch(prod.actions.compare(id));
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  };

  const copyAddr = (evt) => {
    copy(window.location.href);
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  };

  const showShare = (evt) => {
    setModal(true);
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  };

  const handlePrint = (evt) => {
    dispatch(printDialog.actions.show());
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  };

  useEffect(() => onScroll('header-fixed', 200), []);

  return (
    <>
      <div className="clinker-facing__mob" id="header-fixed">
        <p className="header-fixed-name">{name}</p>
        <div className="clinker-facing__href">
          <a onClick={handlePrint} href="#">
            <i className="icon printer" />
          </a>
          <a
            className={`compare-in-fixed  ${inCompare && 'in-compare'}`}
            href="#"
            onClick={toggleCompare}
          >
            <i className="icon chart"></i>
          </a>
          <a href="#" onClick={showShare}>
            <i className="icon share"></i>
          </a>
        </div>
      </div>

      {modal && (
        <Modal>
          <div className="modal-content">
            <div className="back-call__block">
              <div className="close" onClick={() => setModal(false)} />
              <div className="clinker-fac__pad">
                <strong>Поделиться</strong>
                <ul>
                  <li>
                    <a href="#" onClick={copyAddr}>
                      <img src="/static/img/icons/layers.svg" alt="icon" />
                      <span>Скопировать ссылку </span>
                    </a>
                  </li>
                  <li>
                    <VKShareButton url={shareUrl}>
                      <img src="/static/img/icons/wk.svg" alt="icon" />
                      <span>Вконтакте</span>
                    </VKShareButton>
                  </li>
                  <li>
                    <OKShareButton url={shareUrl}>
                      <img src="/static/img/icons/ok.svg" alt="icon" />
                      <span>Одноклассники</span>
                    </OKShareButton>
                  </li>
                  <li>
                    <TelegramShareButton url={shareUrl}>
                      <img
                        src="/static/img/icons/icon-telegram.svg"
                        alt="icon"
                      />
                      <span>Telegram</span>
                    </TelegramShareButton>
                  </li>
                  <li>
                    <TwitterShareButton url={shareUrl}>
                      <img src="/static/img/icons/twiter.svg" alt="icon" />
                      <span>Twitter</span>
                    </TwitterShareButton>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default HeaderFixed;
